import { useParams } from 'react-router-dom';
import { PageHeader, Card, MarkdownView, EmptyState } from '../ui';
import { useBinder } from '../../lib/useBinder';

/** Custom markdown page section backed by adventure.pages. */
export function MarkdownPageSection() {
  const ctx = useBinder();
  const { sectionId } = useParams();
  if (!ctx) return null;
  const { adventure, instance, state, slug } = ctx;
  void instance;
  void state;
  void slug;

  const section = adventure.sections.find((candidate) => candidate.id === sectionId);
  const page = section?.pageId
    ? adventure.pages.find((candidate) => candidate.id === section.pageId)
    : undefined;

  if (!page) {
    return (
      <div>
        <PageHeader eyebrow={section?.icon ?? '📄'} title={section?.title ?? 'Pagina'} />
        <EmptyState
          icon="📄"
          title="Pagina non trovata"
          description="Questa sezione non ha una pagina markdown collegata."
        />
      </div>
    );
  }

  return (
    <div>
      <PageHeader eyebrow={section?.icon ?? page.icon ?? '📄'} title={page.title} />
      <Card>
        <MarkdownView>{page.markdown}</MarkdownView>
      </Card>
    </div>
  );
}
